// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-tree-cell .bolt-table-cell-content {
  padding-bottom: 6px;
  padding-left: 6px;
  padding-top: 6px;
}
.bolt-tree-cell .bolt-tree-cell-content-with-button {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

/*# sourceMappingURL=Tree.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/TreeEx/Tree.scss","webpack://./../azure-devops-ui/bin/Components/TreeEx/Tree.css"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;ACAR;ADGI;EACI,qBAAA;EACA,wBAAA;ACDR;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
